/**
 * Business areas whose status workflow depends on In Home vs At Facility.
 * In Home: 1 Booked → 2 On My Way → 3 Arrived → 4 In Progress → 5 Completed.
 * At Facility: 1 → 4 → 5.
 * The backend picks the workflow from `visit_customer_address` (set by @spike/new-bookings-action from
 * the details type), and "On My Way" (2) is a plain status update instead of grooming's confirm endpoint.
 */
export const SESSION_STATUS_AREAS = ['walking', 'training'] as const;

export type SessionStatusArea = (typeof SESSION_STATUS_AREAS)[number];

export const isSessionStatusArea = (businessArea?: string | null): businessArea is SessionStatusArea =>
    businessArea != null && (SESSION_STATUS_AREAS as ReadonlyArray<string>).includes(businessArea);
